module.exports = __webpack_public_path__ + "img/framenew_box00.f52687ba.jpg";